<div *ngIf="hybrisData && hybrisData.length; else noData">

    <div class="hvac-row">
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-hybris-data-details-col">
            <ul class="layer-view-hybris-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.USER_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].uid | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.USER_STATUS' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].active }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.FIRST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].firstName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.LAST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].lastName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.EMAIL' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].email | textFallback }}</div>
                </li>
            </ul>
        </div>
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-hybris-data-details-col">
            <ul class="layer-view-hybris-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.DEFAULTB2B' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].defaultB2BUnit | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.ROLES' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].roles?.join(', ') | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.HYBRIS_DATA.SOLD_TO_LIST' | translate}}</div>
                    <div class="hvac-col-xs layer-view-hybris-data-list-value hvac-non-edit-mode">{{ hybrisData[0].soldToList?.join(', ') | textFallback }}</div>
                </li>
            </ul>
        </div>
    </div>
</div>
<ng-template #noData>
    <p class="hvac-user-not-found">{{ 'USER_ADMIN.LAYER_VIEW.USER_NOT_FOUND_IN_HYBRIS' | translate}}</p>
</ng-template>
